const WhoWeAre = () => {
    return (
      <section className={("work-section ridge-brdr")+(/*"landing-brdr"*/"")}>
        <div className="inner">
          {/* <div className="col">
            <h1 className="impact-hdr">WHO WE ARE?</h1>
          </div> */}
          <div className="col">
            <p className="who-we-are-text"><b>Equibre</b> is a leading custom web design & development, and software development company started in India and serving worldwide. Our team of skilled & experienced professionals provides world-class development solutions. We don't just convert your ideas into reality; we also help you to nurture them.</p>
          </div>
        </div>
      </section>
    );
  }
  
  export default WhoWeAre